/** WebSocket base URL (protocol + host only); room paths are appended by the clients. */
export function getWsBaseUrl(): string {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  return `${protocol}//${window.location.host}`
}

/**
 * Returns the room path for a given project/room combination.
 * Pass this as the `roomname` parameter to WebsocketProvider.
 */
export function buildWsRoomPath(projectId: string, roomType: string, roomId?: string): string {
  if (roomType === 'presence') {
    return `ws/${projectId}/presence`
  }
  return `ws/${projectId}/${roomType}/${roomId}`
}
